import React from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import lockerBlue from "../../assets/img/lockerBlue.png";
import lockerRed from "../../assets/img/lockerRed.png";
// import lockerYellow from "../../assets/img/lockerYellow.png";
// import lockerGray from "../../assets/img/lockerGray.png";

const CabinetLockerMarker = ({ children, data = {}, ...props }) => {
  let icon = lockerBlue;

  // if (data.operationalStatus === "red") {
  //   icon = lockerRed;
  // } else if (data.operationalStatus === "yellow") {
  //   icon = lockerYellow;
  // } else if (data.operationalStatus === "grey") {
  //   icon = lockerGray;
  // }

  if (data.serviceStatus === "full") {
    icon = lockerRed;
  }

  const boxIcon = new L.icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconAnchor: [9, 55],
    popupAnchor: [10, -44],
    iconSize: [25, 55],
  });

  const markerProps = {
    ...props,
    // icon: selected ? boxIcon : new L.Icon.Default,
    icon: boxIcon,
  };

  // Leaflet-ийн контейнерт илүү DOM зангилаа үлдээхгүйн тулд Marker-ыг шууд буцаана
  return <Marker {...markerProps}>{children}</Marker>;
};

export default CabinetLockerMarker;
